// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserNameCard_wrapper__BhjBZ","name":"UserNameCard_name__WvHDZ","link":"UserNameCard_link__Qq_U4"};